import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import { Box, Text, Button } from '@stitch-fix/mode-react';
import ProfilePhotoSection from './ProfilePhotoSection';
import { SelfieUpload } from '../steps/Selfie/SelfieUpload';
import { FullBodyUpload } from '../FullBodyUpload';
import type { SupportedBusinessLine } from '../Onboarding';
import styles from './ProfilePhotos.module.scss';
type SelfieData = {
  url: string | null;
  refetch: () => void;
};
type FullBodyData = {
  url: string | null;
  id?: string;
  refetch: () => void;
};
export type ProfilePhotosProps = {
  businessLine: SupportedBusinessLine;
  showSelfieRemovalConfirmation?: boolean;
  selfie: SelfieData;
  fullBody: FullBodyData;
};
const ProfilePhotosContent = ({
  businessLine,
  showSelfieRemovalConfirmation = false,
  selfie,
  fullBody
}: ProfilePhotosProps) => {
  const router = useRouter();
  const hasScrolledToFullBodyRef = useRef(false);
  const fullBodySectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (router.query.scrollTo !== 'fullBody' || hasScrolledToFullBodyRef.current || !fullBodySectionRef.current) {
      return;
    }
    hasScrolledToFullBodyRef.current = true;
    fullBodySectionRef.current.scrollIntoView({
      behavior: 'auto',
      block: 'start'
    });
    fullBodySectionRef.current.focus();
  }, [router.query.scrollTo]);
  const handleOnDone = () => {
    router.push('/gallery', '', {
      shallow: true
    });
  };
  return <Box className={styles.profilePhotosContainer} px={1}>
      <Text color="blue-45" setting="title-large" align={{
      sm: 'left',
      lg: 'center'
    }} mb={3}>
        Put a face to the name
      </Text>

      <Box display={{
      sm: 'block',
      lg: 'flex'
    }}>
        <Box className={styles.headshotSection}>
          <ProfilePhotoSection label="Add a headshot" uploadComponent={<SelfieUpload existingImageUrl={selfie.url} onChange={selfie.refetch} showRemovalConfirmation={showSelfieRemovalConfirmation} />} photoType="headshot" businessLine={businessLine} />
        </Box>
        <Box display={{
        sm: 'none',
        lg: 'block'
      }} width="2px" bgColor="gray-85" mx={2} />
        <Box className={styles.fullBodySection} mt={{
        sm: 3,
        lg: 0
      }}>
          <ProfilePhotoSection label="Add a full-body image" uploadComponent={<FullBodyUpload id={fullBody.id} existingImageUrl={fullBody.url} onChange={fullBody.refetch} />} photoType="fullBody" businessLine={businessLine} sectionId="full-body-photo-section" sectionRef={fullBodySectionRef} />
        </Box>
      </Box>
      <Box mt={2} mx={{
      sm: 0,
      lg: 'auto'
    }}>
        <Button width={{
        sm: 'fill',
        lg: 'fixed'
      }} onClick={handleOnDone}>
          Done
        </Button>
      </Box>
    </Box>;
};
export default ProfilePhotosContent;